module.exports = __webpack_public_path__ + "static/media/Asset 6@3x.203f94bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 6@3x.png
// module id = 2394
// module chunks = 0